<template>
  <div class="w3-card">
  <div id="top">
    <user-header v-bind:user="convo.meta.creator" />
    
    <div style="padding-bottom: 5px">
      <div>
      <input type="text" name="commentTitle" placeholder="TITLE" v-model="convo.meta.newCommentTitle" class="form-control">
      </div>
      <div>
      <textarea-autosize rows="3" placeholder="COMMENT" v-model="convo.meta.newCommentBody" class="form-control"></textarea-autosize>
      </div>
      <div>
        <span>
          <save-button @save="addConvoComment()" v-bind:type="'fal'" v-bind:icon="'comment'"/>
        </span>
        <span>
          <button @click="cancel()" type="button" class="w3-button w3-text-theme">
            <font-awesome-icon :icon="['fal', 'times-square']" />
            Cancel
          </button> 
        </span>
      </div>
    </div>
  </div>

  <div>
    Statements:
    <div style='background-color: #c0e0e8; padding-top:5px; padding-bottom: 5px'>
      <div class="w3-container w3-white w3-round w3-margin" v-for="(statement) in convo.meta.newCommentStatements" :key="statement.id">
      <statement-view v-bind:statement="statement" v-bind:buttonType="'comment-remove'" />
      </div>
    </div>

    <br />
    <div class="w3-container w3-card w3-white w3-round w3-margin-left w3-margin-bottom" v-for="(statement) in statements" :key="statement.id">
      <statement-view v-bind:statement="statement" v-bind:buttonType="'comment-add'" />
    </div>
  </div>

  <hr class="w3-clear">
  </div>
</template>

<script>
  import ConvoCommentStatementEdit from "./ConvoCommentStatementEdit.ts";

  export default ConvoCommentStatementEdit;
</script>
